import React from 'react'
import { Navbar, Footer, Newsbar } from "../../components"
import { Gas } from './'

export default function OtherModeling() {
  return (
    <div className='emas__othermodeling'>
        <Navbar />
        <Gas />
        <Newsbar />
        <Footer />
    </div>
  )
}
